export default __webpack_public_path__ + "static/char-v-08-a617dc662aed1766b604249ec34eb5bf.png";